import { render, staticRenderFns } from "./Ideas-Show.vue?vue&type=template&id=0158f7f3&scoped=true&"
import script from "./Ideas-Show.vue?vue&type=script&lang=js&"
export * from "./Ideas-Show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158f7f3",
  null
  
)

export default component.exports